
import { TranslationsType, TranslationSchema } from "../types";
import { enTranslations } from './en';
import { deTranslations } from './de';
import { frTranslations } from './fr';
import { esTranslations } from './es';

// Create a map of all translations
export const translationsMap: TranslationsType = {
  en: enTranslations,
  de: deTranslations,
  fr: frTranslations,
  es: esTranslations
};

// Export a function to get translations for a specific language
export const getTranslation = (language: keyof TranslationsType): TranslationSchema => {
  return translationsMap[language];
};

// Export the consolidated translations object (for backward compatibility)
export const translations = {
  cookieBanner: {
    en: enTranslations.cookieBanner,
    de: deTranslations.cookieBanner,
    fr: frTranslations.cookieBanner,
    es: esTranslations.cookieBanner
  },
  legalPages: {
    en: enTranslations.legalPages,
    de: deTranslations.legalPages,
    fr: frTranslations.legalPages,
    es: esTranslations.legalPages
  }
};

// Helper to create a hook or use the translations
export const useTranslation = (language: keyof TranslationsType) => {
  const t = translationsMap[language];
  return { t };
};
